<template>
  <div class="Dialog prize-result live" v-if="isLiveShown">
    <div class="inner">
      <div class="pic-bg"></div>
      <div class="pic-birld"></div>
      <div class="pic-cloud"></div>

      <div class="icon-close" @click="send('CLOSE_LIVE')"></div>
      <div class="live-box">
        <div class="live-scroll">
          <img class="live-s" src="../../../../ui/20201111king_double_eleven/assets/live-img.png" alt="" />
          <img class="live-h" src="../../../../ui/20201111king_double_eleven/assets/live-img-h.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { computed } from "@vue/composition-api"

export default {
  props: ["state", "send"],

  setup(props) {
    const isLiveShown = computed(() => {
      return ["nowLives"].some(props.state.matches)
    })

    return {
      isLiveShown
    }
  }
}
</script>
